import React, {useContext, useEffect, useState} from 'react';

import LazyLoading from "../../components/LazyLoading";
import {Col, Form, Modal, Row} from "@themesberg/react-bootstrap";
import {BASE_URL} from "../../config";
import {LOCAL_STORAGE} from "../../context/LocalStorage";
import fetchWrapper from "../../utils/fetch/fetchWrapper";

const ModalForm = ({showModal,setShowModal,id,setId, fetchData}) => {

    const [dataForm, setDataForm] = useState({});

    let token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)

    useEffect(() => {
        if(showModal && id != null){
            fetchWrapper()
                    .doPost({
                        url: "/find_category",
                        body:{
                            id: id
                        },
                        onSuccess: async (response) => {
                            setDataForm(response.data.data.category)
                        },
                        onError: (response) => {
                            alert(response.data.message);
                        },
                        })
                        .then(() => {
                        })
                        .catch((error) => {
                        });
        //     axios({
        //     method: "post",
        //     url: BASE_URL + "/find_category",
        //     headers: {
        //         'Authorization': token
        //     },
        //     data: {
        //         id: id,
        //     },
        //     timeout: 5000,
        // })
        //     .then(
        //         function (response) {
        //             if (response.data.status == 200) {
        //                 setDataForm(response.data.data.category)
        //             }
        //         }.bind(this)
        //     )
        //     .catch(function (error) {
        //         console.log(error)
        //         if (error.response) {
        //             console.log(error.message);
        //             alert(response.data.message);
        //         } else if (error.request) {
        //             alert("Error de conexion");
        //         } else {
        //             alert(error.message);
        //         }
        //     });


        }
    }, [showModal]);

    const saveModal = () => {

        let url = '/store_category';

        if(id != null){
            url = '/update_category';
        }
        fetchWrapper()
                    .doPost({
                        url: url,
                        body:dataForm,
                        onSuccess: async (response) => {
                            fetchData()
                            handleClose()
                        },
                        onError: (response) => {
                            alert(response.data.message);
                        },
                        })
                        .then(() => {
                        })
                        .catch((error) => {
                        });
        // axios({
        //     method: "post",
        //     url: BASE_URL + url,
        //     headers: {
        //         'Authorization': token
        //     },
        //     data: dataForm,
        //     timeout: 5000,
        // })
        //     .then(
        //         function (response) {
        //             if (response.data.status == 200) {
        //                 fetchData()
        //                 handleClose()

        //             }
        //         }.bind(this)
        //     )
        //     .catch(function (error) {
        //         if (error.response) {
        //             console.log(error.message);
        //             // console.log(response.data.message);
        //             alert(response.data.message);
        //         } else if (error.request) {
        //             alert("Error de conexion");
        //         } else {
        //             // console.log(error.message);
        //             alert(error.message);
        //         }
        //     });

    }

    const dataOnChange = (e) => {
        setDataForm({
            ...dataForm,
            [e.target.name]: e.target.value
        })
    }

    const handleClose = () => {
        setShowModal(false);
        setId(null)
        setDataForm({})
    }

    return (
            <Modal show={showModal} onHide={() => handleClose()}

                   size="lg"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Crear Categoría
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col md={12} className="mb-3">
                      <Form.Group id="firstName">
                        <Form.Label>Categoría</Form.Label>
                        <Form.Control onChange={dataOnChange} value={dataForm.hasOwnProperty("title") ? dataForm.title : ''} name="title" type="text" placeholder="Ingresa tu categoría" required/>
                      </Form.Group>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-light" onClick={() => handleClose()}>Cerrar</button>
                    <button className="btn btn-primary" onClick={() => saveModal()}>Guardar</button>
                </Modal.Footer>
            </Modal>


    );
};

export default ModalForm
